import useSWR from "swr";
import { useSelector } from "react-redux";
import { fetcher } from "../../../../services/fetcher";
import { Select, } from "@mantine/core";

const baseUrl = 'issuance/user-cover-plan-access';

const CreateBooking = ({ selectedValue, policyType, selectedCover, setSelectedCover, selectedOperatorId }) => {
  const userProfile = useSelector((state) => state.userProfile);
  const userRole = userProfile?.user?.role;

  const getApiUrl = () => {
    if (!userRole) return null;
    
    if (selectedValue === "User" && ["Issuance Team", "Sales Team", "Super Admin"].includes(userRole)) {
      return `${baseUrl}/?policy_type=${policyType}&issue_as=agent`;
    } else if (selectedValue === "Operator" && selectedOperatorId) {
      return `${baseUrl}/?policy_type=${policyType}&issue_as=operator&operator=${selectedOperatorId}`;
    }
    return null;
  };

  const apiUrl = getApiUrl();
  const { data } = useSWR(
    apiUrl ? [apiUrl, "GET"] : null,
    ([url, method]) => fetcher(url, method), 
    { revalidateOnFocus: false, shouldRetryOnError: false }
  );

  const coverOptions = data?.covers?.flatMap((cover) =>
    cover.customize_covers?.map((item) => ({
      value: item.id.toString(),
      label: `${item.title} - ${item.price} ${item.currency}`,
    })) || []
  ) || [];
  
  return (
    <>
      {policyType === "bulk" && selectedValue === "User" && coverOptions.length > 0 && ( 
        <Select
          label="Choose Plan"
          placeholder="Select Plan"
          rules={{ required: "Plan is required" }}
          data={coverOptions}
          value={selectedCover?.value || ""}
          onChange={(value) => {
              const selected = coverOptions.find((option) => option.value === value);
              setSelectedCover(selected || null); 
          }}
          mt="lg"
          clearable
          searchable
          withAsterisk
        />
      )}
    </>
  );
};

export default CreateBooking;